<div class="widget-navigation-card card h-100 border-none" [ngClass]="cssClass" [attr.id]="id" [style.margin-top]="marginTop" [style.margin-right]="marginRight" [style.margin-bottom]="marginBottom" [style.margin-left]="marginLeft">
  <img class="mw-100" [src]="imageUrl" [attr.alt]="imageDescription" />
  @if (description != undefined) {
    <div class="header">{{ description }}</div>
  }
  @if (url != undefined) {
    <app-link [url]="url" classes="stretched-link"></app-link>
  }
  @if (message != undefined) {
    <div class="message">{{ message }}</div>
  }
</div>
